export default __webpack_public_path__ + "static/media/react.93a4bdf1.png";